import { StepNoticeModel, StepNoticeType, StepNoticeWithContentModel } from '@partful/instructions-domain-models';
import { classNames } from '@partful/shared/lib/classNames';
import { Typography } from '@partful/shared/ui/Typography';
import { useMemo } from 'react';
import styles from './StepNotice.module.scss';
import { StepNoticeControls, StepNoticeControlsProps } from './StepNoticeControls';
import { StepNoticeIcon } from './StepNoticeIcon';

interface StepNoticeProps extends StepNoticeControlsProps {
  notice: StepNoticeModel & Partial<StepNoticeWithContentModel>;
}

export function StepNotice({ notice: { order, type, content }, ...controls }: Readonly<StepNoticeProps>) {
  const className = useMemo(() => {
    switch (type) {
      case StepNoticeType.Safety:
        return styles.safety;
      case StepNoticeType.Warning:
        return styles.warning;
      case StepNoticeType.Danger:
        return styles.danger;
      default:
        return styles.info;
    }
  }, [type]);

  return (
    <div className={styles.container}>
      <StepNoticeControls {...controls} />
      <div className={classNames(styles.notice, className)} data-testid={`step-notice-${order}`}>
        <StepNoticeIcon className={styles.icon} type={type} />
        <div className={styles.content}>
          <Typography fontWeight={600} data-testid={`step-notice-${order}-title`}>
            {content?.title}
          </Typography>
          <Typography data-testid={`step-notice-${order}-description`}>{content?.description}</Typography>
        </div>
      </div>
    </div>
  );
}
